import _extends from "@babel/runtime/helpers/extends";
import { TextButton } from '@wix/design-system';
import React from 'react';
const Noop = () => {
  return null;
};
export const getTranslationTags = props => {
  const {
    url,
    darkLink
  } = props || {};
  const Link = url ? /*#__PURE__*/React.createElement(TextButton, _extends({
    as: "a",
    href: url,
    size: "tiny",
    target: "_blank"
  }, darkLink && {
    skin: 'dark',
    underline: 'always'
  })) : /*#__PURE__*/React.createElement(Noop, null);
  return {
    Link,
    voucher: /*#__PURE__*/React.createElement(Noop, null),
    b: /*#__PURE__*/React.createElement("b", null)
  };
};
//# sourceMappingURL=getTranslationTags.js.map